(function () {
  const B2B_REGISTRATION_PATH = '/pages/b2b-registrierung';

  const wrongLinkPattern = /\/apps\/wpdapp|\/account\/register/i;

  function isWrongRegistrationLink(url) {
    return typeof url === 'string' && wrongLinkPattern.test(url);
  }

  function fixAnchor(anchor) {
    if (!anchor.href || anchor.dataset.b2bLinkFixed === 'true') return;
    if (!isWrongRegistrationLink(anchor.href)) return;

    anchor.href = B2B_REGISTRATION_PATH;
    anchor.dataset.b2bLinkFixed = 'true';
  }

  function fixLinks(root) {
    if (!root) return;

    if (root.matches && root.matches('a[href]')) {
      fixAnchor(root);
    }

    root.querySelectorAll?.('a[href]').forEach(fixAnchor);
  }

  function handleClick(event) {
    const anchor = event.target.closest('a[href]');
    if (!anchor || !isWrongRegistrationLink(anchor.href)) return;

    event.preventDefault();
    window.location.assign(B2B_REGISTRATION_PATH);
  }

  function init() {
    fixLinks(document);
    document.addEventListener('click', handleClick, true);

    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            fixLinks(node);
          }
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
